
<div class="row" style="text-align: center;">
    <div class="col-md-10 col-lg-10 col-sm-10" style="text-align: center;">
        <div style="text-align: center;">
            <h3 style="color: black;"><b>Work List</b></h3>
        </div>
        <div class="row" *ngIf="!dataLoaded">
            <div>
                <p class="animate"></p>
            </div>
        </div>
        <div class="d-flex justify-content-end" *ngIf="dataLoaded">
            <button class="btn btn-sm btn-success mb-2" (click)="goto('admin_panel/user/createuser')">View in Customer 360</button>
        </div>
        <div class="card-box" *ngIf="dataLoaded" style="margin: 20px;">
            <ag-grid-angular #agGrid style="width: auto; height: 500px;" class="ag-theme-alpine" [rowData]="myrowData"
                [rowSelection]="'multiple'" [columnDefs]="columnDefs" [pagination]="true">
            </ag-grid-angular>
        </div>
    </div>
</div>